/**
 * ## cortex:std:debug
 * Module to "assert" certain criteria within the code. If code is being
 * executed in a production environment it'll throw an error. If code is being
 * executed in a development environment call "debugger" first.
 *
 * ### Code example
 *
 * ```ts
 * const valueFromService = getValueFromService()!;
 * // throws an error if null or undefined. If dev env it'll launch the debugger before the throw
 * Debug.assertDeclared(valueFromService);
 *
 * // continue with valueFromService being defined
 * ```
 */
export namespace Debug {
	/** Asserts value's truthiness, if false -> fail */
	export function assert<T>(expression: T, message?: string): expression is T {
		if (!expression) {
			throw new Error(message ?? 'assertion failed');
		}

		return true;
	}

	/** Asserts that value is not undefined or null */
	export function assertDeclared<T>(value: T, message?: string): value is NonNullable<T> {
		if (typeof value === 'undefined' || value === null) {
			throw new Error(message ?? 'assertDeclared');
		}

		return true;
	}
}
